
export const NEVER_TOKEN = 'never_token';
